export default __webpack_public_path__ + "static/media/interllectualLife.f06ce7a1.jpeg";